// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b4d86616","250":"26e00fb2","253":"8a1ebade","423":"75cf1f8b","440":"72574022","469":"ec15d9c2","488":"652f4433","752":"2126a82a","763":"3f257555","823":"30931360"}[chunkId] + ".chunk.js";
};